import {
  Progress,
  Box,
  ButtonGroup,
  Button,
  Heading,
  Flex,
  FormControl,
  GridItem,
  FormLabel,
  Input,
  Stack,
  Image,
  Checkbox,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  FormHelperText,
  SimpleGrid,
  useDisclosure,
} from "@chakra-ui/react";
import { IoIosRemoveCircle } from "react-icons/io";
import { useToast } from "@chakra-ui/react";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEventDetails } from "../../Redux/App/action";
import { BsCardImage } from "react-icons/bs";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
const Form1 = ({ formData, setFormData }) => {
  return (
    <>
      <Heading
        w="100%"
        fontFamily={"lato"}
        textAlign={"center"}
        fontWeight="normal"
        mb="2%"
      >
        Event Details
      </Heading>
      <Flex>
        <FormControl mr="5%" isRequired>
          <FormLabel htmlFor="event-type" fontWeight={"normal"}>
            Event Type
          </FormLabel>
          <Input
            id="event-type"
            placeholder="e.g Birthday, Wedding"
            value={formData.eventType}
            onChange={(e) =>
              setFormData({ ...formData, eventType: e.target.value })
            }
          />
        </FormControl>

        <FormControl isRequired>
          <FormLabel htmlFor="event-name" fontWeight={"normal"}>
            Event Name
          </FormLabel>
          <Input
            id="event-name"
            placeholder="e.g Piyush's Birthday"
            value={formData.eventName}
            onChange={(e) =>
              setFormData({ ...formData, eventName: e.target.value })
            }
          />
        </FormControl>
      </Flex>

      <Flex>
        <FormControl mr="5%" isRequired>
          <FormLabel htmlFor="expected-guests" fontWeight={"normal"}>
            Expected Guest
          </FormLabel>
          <Input
            id="expected-guests"
            placeholder="Expected number of guests"
            value={formData.expectedGuests}
            onChange={(e) =>
              setFormData({ ...formData, expectedGuests: e.target.value })
            }
          />
        </FormControl>

        <FormControl isRequired>
          <FormLabel htmlFor="event-timing" fontWeight={"normal"}>
            Event Timing
          </FormLabel>
          <Input
            placeholder="Event Timing"
            h={8}
            type="datetime-local"
            value={formData.eventTiming}
            onChange={(e) =>
              setFormData({ ...formData, eventTiming: e.target.value })
            }
          />
        </FormControl>
      </Flex>

      <FormControl mt="2%" isRequired>
        <FormLabel htmlFor="event-details" fontWeight={"normal"}>
          Event Details
        </FormLabel>
        <Input
          id="event-details"
          value={formData.eventDetails}
          onChange={(e) =>
            setFormData({ ...formData, eventDetails: e.target.value })
          }
        />
        <FormHelperText>
          Let your guests know special information e.g. A Dress Code
        </FormHelperText>
      </FormControl>
    </>
  );
};

const Form2 = ({
  formData,
  setFormData,
  handleFileInputChange,
  selectedImages,
  rsvp,
  setRsvp,
  setEshagun,
  eshagun,
  upiId,
  setupiId,
  setComment,
  comment,
  setAddWishlist,
  addwishlist,
  Text,
  setAccomodation,
  accomodation,
  setfligth,
  fligth,
  setAuthorize,
  authorize,
  authorizeMemberList,
  handleInputChange,
  handleRemoveFields,
  handleAddFields,
  AiOutlineUserAdd,
}) => {
  return (
    <>
      <Heading
        w="100%"
        fontFamily={"lato"}
        textAlign={"center"}
        fontWeight="normal"
        mb="2%"
      >
        Venue Details
      </Heading>

      <FormControl as={GridItem} colSpan={6} isRequired>
        <FormLabel
          htmlFor="address"
          fontSize="sm"
          fontWeight="md"
          color="gray.700"
          _dark={{
            color: "gray.50",
          }}
          mt="2%"
        >
          Venue Address
        </FormLabel>

        <Input
          type="text"
          name="address"
          id="address"
          autoComplete="street-address"
          focusBorderColor="brand.400"
          shadow="sm"
          size="sm"
          w="full"
          rounded="md"
          value={formData.address}
          onChange={(e) =>
            setFormData({ ...formData, address: e.target.value })
          }
        />
      </FormControl>

      <FormControl as={GridItem} colSpan={[6, 6, null, 2]} isRequired>
        <FormLabel
          htmlFor="Pincode"
          fontSize="sm"
          fontWeight="md"
          color="gray.700"
          _dark={{
            color: "gray.50",
          }}
          mt="2%"
        >
          Pincode
        </FormLabel>
        <Input
          type="text"
          name="Pincode"
          id="Pincode"
          autoComplete="city"
          focusBorderColor="brand.400"
          shadow="sm"
          size="sm"
          w="full"
          rounded="md"
          value={formData.Pincode}
          onChange={(e) =>
            setFormData({ ...formData, Pincode: e.target.value })
          }
        />
      </FormControl>

      <Stack spacing={4}>
        <FormControl as={GridItem} colSpan={[6, 3, null, 2]}>
          <FormLabel
            htmlFor="venue-image"
            fontSize="sm"
            fontWeight="md"
            color="gray.700"
            mt="2%"
          >
            Upload Venue Images (max 10)
          </FormLabel>
          <Input
            type="file"
            name="venue-image"
            id="venue-image"
            multiple // Allow multiple file selection
            onChange={handleFileInputChange}
            accept="image/*" // Allow only image files
            focusBorderColor="brand.400"
            shadow="sm"
            size="sm"
            w="full"
            rounded="md"
          />
        </FormControl>

        {/* Display selected images */}
        <Stack direction="row" spacing={2} flexWrap="wrap">
          {selectedImages.map((image, index) => (
            <Image
              key={index}
              src={URL.createObjectURL(image)}
              alt={`Image ${index + 1}`}
              maxW="100px"
              maxH="100px"
              mb={index % 5 === 4 ? "2" : "0"}
            />
          ))}
        </Stack>
      </Stack>

      <FormControl as={GridItem}>
        <Flex flexDirection="column" mt={2}>
          <Checkbox
            onChange={() => {
              setRsvp(!rsvp);
            }}
          >
            Request RSVP
          </Checkbox>
          <Checkbox
            onChange={() => {
              setEshagun(!eshagun);
            }}
          >
            Allow Eshagun
          </Checkbox>
          {eshagun ? (
            <Box w={"50%"}>
              <Input
                placeholder="UPI ID"
                value={upiId}
                onChange={(e) => setupiId(e.target.value)}
              />
            </Box>
          ) : null}
          <Checkbox
            onChange={() => {
              setComment(!comment);
            }}
          >
            Allow Comments Wall
          </Checkbox>
          <Checkbox
            onChange={() => {
              setAddWishlist(!addwishlist);
            }}
          >
            Create & Display Wishlist
          </Checkbox>
        </Flex>

        {addwishlist ? (
          <Text textAlign={"center"}>To Be Added Soon...</Text>
        ) : null}
        <Flex
          gap={10}
          boxShadow={
            "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;"
          }
          w={"60%"}
          m={"auto"}
          mt={2}
          justifyContent={"center"}
        >
          <Checkbox
            onChange={() => {
              setAccomodation(!accomodation);
            }}
          >
            Accommodations
          </Checkbox>
          <Checkbox
            onChange={() => {
              setfligth(!fligth);
            }}
          >
            Flight Details
          </Checkbox>
        </Flex>

        <Checkbox
          onChange={() => {
            setAuthorize(!authorize);
          }}
          mt={2}
        >
          Authorize Family/Friends to Manage/Send more Invitations
        </Checkbox>
        {authorize ? (
          <Box
            w={"90%"}
            boxShadow={
              "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;"
            }
            m={"auto"}
            mt={2}
            h={130}
            borderRadius={10}
            px={2}
            overflowY={"auto"}
          >
            {authorizeMemberList.map((field, index) => (
              <Flex
                key={index}
                alignItems="center"
                justifyContent="space-between"
                gap={2}
              >
                <Box w="45%" fontSize={12}>
                  <Text>Name</Text>
                  <Input
                    name="name"
                    placeholder="Name"
                    value={field.name}
                    onChange={(e) => handleInputChange(index, e)}
                  />
                </Box>
                <Box w="45%" fontSize={12}>
                  <Text>Mobile</Text>
                  <Input
                    name="mobile"
                    placeholder="Mobile"
                    value={field.mobile}
                    onChange={(e) => handleInputChange(index, e)}
                  />
                </Box>
                <Box w="10%" fontSize={12}>
                  <Text>Remove</Text>
                  <Button
                    onClick={() => handleRemoveFields(index)}
                    colorScheme="red"
                  >
                    <IoIosRemoveCircle />
                  </Button>
                </Box>
              </Flex>
            ))}
            <Button onClick={handleAddFields} colorScheme="green">
              <AiOutlineUserAdd />
            </Button>
          </Box>
        ) : null}
      </FormControl>
    </>
  );
};

const Form3 = ({ formData, setFormData, Submit, handleWhatsAppShare }) => {
  return (
    <>
      <Heading
        w="100%"
        fontFamily={"lato"}
        textAlign={"center"}
        fontWeight="normal"
        mb={"5"}
      >
        Share Invitation
      </Heading>

      <SimpleGrid columns={1} spacing={6}>
        <Flex flexDir={"row"} justifyContent={"space-between"}>
          <Table variant="simple">
            <Thead>
              <Tr>
                <Th>Name</Th>
                <Th>Email</Th>
                <Th>Mobile Number</Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td>
                  <Input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                  />
                </Td>
                <Td>
                  <Input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                  />
                </Td>
                <Td>
                  <Input
                    type="text"
                    name="mobile"
                    value={formData.mobile}
                    onChange={(e) =>
                      setFormData({ ...formData, mobile: e.target.value })
                    }
                  />
                </Td>
                <Td>
                  <Button size={"xs"} colorScheme="red">
                    <IoIosRemoveCircle />
                  </Button>
                </Td>
                <Td>
                  <Button size={"xs"} colorScheme="green">
                    +
                  </Button>
                </Td>
              </Tr>
            </Tbody>
          </Table>
        </Flex>

        <Button fontSize="18px" w="100%" fontWeight="semibold" onClick={Submit}>
          Share Via Email
        </Button>

        <FormControl>
          <Button
            fontSize={"18px"}
            w="100%"
            textAlign={"left"}
            fontWeight="semibold"
            onClick={handleWhatsAppShare}
          >
            Share Via WhatsApp
          </Button>
        </FormControl>
      </SimpleGrid>
    </>
  );
};

export default function Multistep() {
  const toast = useToast();
  const [step, setStep] = useState(1);
  const [progress, setProgress] = useState(33.33);
  const preview = localStorage.getItem("previewId");
  const [excelData, setExcelData] = useState([]);
  const [previewRes, setPreviewRes] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const accessToken = localStorage.getItem("token");
  const imagePreview = localStorage.getItem("imagePreview");
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);
  const { allEvents } = useSelector((store) => store.appReducer);
  const [eventName, seteventName] = useState("");
  const [eventType, seteventType] = useState("");
  const [venue, setvenue] = useState("");
  const [eventDetails, seteventDetails] = useState("");
  const [eventTiming, seteventTiming] = useState("");
  const [expectedNoOfGuests, setexpectedNoOfGuests] = useState("");
  const [venuePinCode, setvenuePinCode] = useState("");
  const [address1, setAddress1] = useState("");
  const [comment, setComment] = useState(false);
  const [upiId, setupiId] = useState("");
  const [optionalSourceImgId, setoptionalSourceImgId] = useState(0);
  const [tid, setTid] = useState("");
  const imageRef = useRef(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [eventId, seteventId] = useState("");
  const calender = useRef(null);
  const [imageId, setImageId] = useState([]);
  const [addwishlist, setAddWishlist] = useState(false);
  const [authorize, setAuthorize] = useState(false);
  const [downloading, setDownloding] = useState(false);
  const [rsvp, setRsvp] = useState(false);
  const [eshagun, setEshagun] = useState(false);
  const [authorizeMemberList, setInputFields] = useState([
    { name: "", mobile: "" },
  ]);
  const [accomodation, setAccomodation] = useState(false);
  const [fligth, setfligth] = useState(false);

  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const newInputFields = [...authorizeMemberList];
    newInputFields[index][name] = value;
    setInputFields(newInputFields);
  };

  const handleAddFields = () => {
    setInputFields([...authorizeMemberList, { name: "", mobile: "" }]);
  };

  const handleRemoveFields = (index) => {
    const newInputFields = [...authorizeMemberList];
    newInputFields.splice(index, 1);
    setInputFields(newInputFields);
  };
  const handleFileUpload = (e) => {
    const file = e.target.files[0];

    if (!file) {
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet);
      setExcelData(jsonData);
    };

    reader.readAsArrayBuffer(file);
  };

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "exportedData.xlsx");
  };

  const handleFileChange = (e) => {
    const files = e.target.files;

    if (files.length > 10) {
      setErrorMessage("You can only upload a maximum of 10 images.");
      e.target.value = ""; // Clear the selected files
    } else {
      setErrorMessage("");
      setSelectedImages(Array.from(files));
      // Handle the selected files here
    }
  };

  useEffect(() => {
    dispatch(getEventDetails);
  }, [dispatch]);
  const handleImage = () => {
    const formData = new FormData();

    formData.append("productFiles", ...selectedImages);
    axios
      .post(
        `https://dev.api.wishfy.io/media/media/file/admin/upload/productfiles?imageGroup=PRODUCT`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token: "123456",
          },
        },
      )
      .then((response) => {
        setImageId(response.data);
        setoptionalSourceImgId(response.data[0].sourceMediaId);
      })
      .catch((error) => {
        console.log(`${error.message}`);
      });
  };

  const handleWhatsAppShare = () => {
    const whatsappUrl = `https://wa.me/send?text=${imagePreview}`;
    window.open(whatsappUrl);
  };
  const Submit = () => {
    const formData = new FormData();
    formData.append("eventId", 10);
    formData.append("eventOptionRequestDto.accomodationFlag", accomodation);
    formData.append("eventOptionRequestDto.flightFlag", fligth);
    formData.append("eventOptionRequestDto.requestRSVP", rsvp);
    formData.append("eventOptionRequestDto.allowCommentsWall", comment);
    formData.append(
      "eventOptionRequestDto.authorizeMemeberToManage",
      authorize,
    );
    formData.append("eventOptionRequestDto.eshagunFlag", eshagun);
    formData.append("eventRequestDTO.eventName", eventName);
    formData.append("eventRequestDTO.eventType", eventType);
    formData.append("eventRequestDTO.venue", address1);
    formData.append("eventRequestDTO.venuePincode", venuePinCode);
    formData.append("eventRequestDTO.eventDetails", eventDetails);
    formData.append("eventRequestDTO.eventTiming", eventTiming);
    formData.append("eventRequestDTO.expectedNoOfGuests", expectedNoOfGuests);
    formData.append("eventRequestDTO.venueImg", imageId);
    authorizeMemberList.forEach((inputFields, index) => {
      formData.append(
        `authorizeMemberList[${index}].authorizeMemberName`,
        inputFields.name,
      );
      formData.append(
        `authorizeMemberList[${index}].authorizeMemberMobileNo`,
        inputFields.mobile,
      );
    });
    formData.append("upiId", "arpit1143@ybl");
    formData.append("templateId", tid);
    formData.append("sharingModeType", "whatsapp");
    formData.append("invitationDetails[0].sourceMediaId", "");
    formData.append("invitationDetails[0].guestName", "");
    formData.append("invitationDetails[0].guestPhoneNumber", "");
    formData.append("invitationDetails[0].guestEmail", "");

    axios
      .post(
        `https://dev.api.wishfy.io/events/invitation/card/display`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        },
      )
      .then((response) => {
        console.log(response.data);
        window.location.reload();
      })
      .catch((error) => {
        console.log(`${error.message}`);
      });
  };

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("eventName", eventName);
    formData.append("eventType", eventType);
    formData.append("venue", venue);
    formData.append("eventDetails", eventDetails);
    formData.append("eventTiming", eventTiming);
    formData.append("expectedNoOfGuests", expectedNoOfGuests);
    formData.append("venuePincode", venuePinCode);
    formData.append("venueImg", optionalSourceImgId);
    axios
      .post(`https://dev.api.wishfy.io/events/create`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        window.location.reload();
      })
      .catch((error) => {
        console.log(`${error.message}`);
      });
  };

  useEffect(() => {
    setActiveTab(1);
  }, []);
  const handlePreview = () => {
    axios
      .get(
        `https://dev.api.wishfy.io/template/template-builder/get/user/template/by-id?id=${preview}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        },
      )
      .then((response) => {
        setPreviewRes(response.data.payload.invitationImgPreview);
        setTid(response.data.payload.id);
      })
      .catch((error) => {
        console.log(`${error.message}`);
      });
  };
  useEffect(() => {
    handlePreview();
  }, []);

  const [formData, setFormData] = useState({
    eventType: "",
    eventName: "",
    expectedGuests: "",
    eventTiming: "",
    eventDetails: "",
    address: "",
    Pincode: "",
    selectedImages: [],
    // Add more fields as needed
  });

  const handleFileInputChange = (e) => {
    const files = e.target.files;
    if (files.length + formData.selectedImages.length > 10) {
      alert("You can upload a maximum of 10 images.");
    } else {
      setFormData({
        ...formData,
        selectedImages: [...formData.selectedImages, ...files],
      });
    }
  };

  const handleFormSubmit = () => {
    const postData = {
      eventId: 0,
      eventOptionRequestDto: {
        // Extract options from your form
      },
      eventRequestDTO: {
        eventName: formData.eventName,
        eventType: formData.eventType,
        venue: formData.address,
        venuePincode: formData.Pincode,
        eventDetails: formData.eventDetails,
        eventTiming: formData.eventTiming,
        expectedNoOfGuests: formData.expectedGuests,
        venueImg: formData.selectedImages.length,
      },
      // Add more data as needed
    };

    fetch("http://localhost:8083/events/invitation/card/display", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`, // Replace with your actual access token
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        toast({
          title: "Invitation Sent.",
          description: "We've sent your invitation for you.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <Box
      borderWidth="1px"
      rounded="lg"
      shadow="1px 1px 3px rgba(0,0,0,0.3)"
      maxWidth={800}
      p={6}
      m="10px auto"
      as="form"
    >
      <Progress
        hasStripe
        value={progress}
        mb="5%"
        mx="5%"
        isAnimated
      ></Progress>
      {step === 1 ? (
        <Form1 formData={formData} setFormData={setFormData} />
      ) : step === 2 ? (
        <Form2
          formData={formData}
          setFormData={setFormData}
          handleFileInputChange={handleFileInputChange}
          selectedImages={formData.selectedImages}
        />
      ) : (
        <Form3 formData={formData} setFormData={setFormData} />
      )}
      <ButtonGroup mt="5%" w="100%">
        <Flex w="100%" justifyContent="space-between">
          <Flex>
            <Button
              onClick={() => {
                setStep(step - 1);
                setProgress(progress - 33.33);
              }}
              isDisabled={step === 1}
              colorScheme="teal"
              variant="solid"
              w="7rem"
              mr="5%"
            >
              Back
            </Button>
            <Button
              w="7rem"
              isDisabled={step === 3}
              onClick={() => {
                setStep(step + 1);
                if (step === 3) {
                  setProgress(100);
                } else {
                  setProgress(progress + 33.33);
                }
              }}
              colorScheme="teal"
              variant="outline"
            >
              Next
            </Button>
          </Flex>
          {step === 3 ? (
            <Button
              w="30%"
              padding={"2"}
              color={"white"}
              bgColor={"#22C15D"}
              variant="solid"
              onClick={handleFormSubmit}
            >
              Send Invitation
            </Button>
          ) : null}
        </Flex>
      </ButtonGroup>
    </Box>
  );
}
